import { useRef } from 'react';
import { useDragLayer } from 'react-dnd';
import { calculatePointerPosition } from './offsets';

const getStyle = currentOffset => {
  const transform = "translate(".concat(currentOffset.x.toFixed(1), "px, ").concat(currentOffset.y.toFixed(1), "px)");
  return {
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    transform,
    WebkitTransform: transform
  };
};

export const usePreview = () => {
  const child = useRef(null);
  const collectedProps = useDragLayer(monitor => {
    return {
      currentOffset: calculatePointerPosition(monitor, child),
      isDragging: monitor.isDragging(),
      itemType: monitor.getItemType(),
      item: monitor.getItem(),
      monitor
    };
  });

  if (!collectedProps.isDragging || collectedProps.currentOffset === null) {
    return {
      display: false
    };
  }

  return {
    display: true,
    itemType: collectedProps.itemType,
    item: collectedProps.item,
    style: getStyle(collectedProps.currentOffset),
    monitor: collectedProps.monitor,
    ref: child
  };
};